import { useUser } from '@clerk/clerk-react';

export const useAuth = () => {
  const { user } = useUser();
  
  return {
    user,
    userId: user?.id,
    isAuthenticated: !!user,
    isLoading: !user && user !== null, // Clerk is still loading
  };
};